import { useTranslation } from 'react-i18next';

const offeringsData = [
  {
    icon: 'ri-restaurant-2-line',
    titleKey: 'about_exp_1_title',
    descKey: 'about_exp_1_desc',
    tagKey: 'about_exp_1_tag',
  },
  {
    icon: 'ri-fire-line',
    titleKey: 'about_exp_2_title',
    descKey: 'about_exp_2_desc',
    tagKey: 'about_exp_2_tag',
  },
  {
    icon: 'ri-bowl-line',
    titleKey: 'about_exp_3_title',
    descKey: 'about_exp_3_desc',
    tagKey: 'about_exp_3_tag',
  },
  {
    icon: 'ri-cup-line',
    titleKey: 'about_exp_4_title',
    descKey: 'about_exp_4_desc',
    tagKey: 'about_exp_4_tag',
  },
  {
    icon: 'ri-truck-line',
    titleKey: 'about_exp_5_title',
    descKey: 'about_exp_5_desc',
    tagKey: 'about_exp_5_tag',
  },
  {
    icon: 'ri-calendar-event-line',
    titleKey: 'about_exp_6_title',
    descKey: 'about_exp_6_desc',
    tagKey: 'about_exp_6_tag',
  },
];

export default function OurExperience() {
  const { t } = useTranslation();

  return (
    <section className="bg-black py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-16">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-0.5 bg-[#F57F25]"></div>
              <span className="text-[#F57F25] text-xs font-bold tracking-widest uppercase">{t('about_exp_eyebrow')}</span>
            </div>
            <h2 className="text-4xl md:text-5xl font-black text-white uppercase leading-tight">
              {t('about_exp_title')} <span className="text-[#F57F25]">{t('about_exp_title_accent')}</span>
            </h2>
          </div>
          <p className="text-white/50 text-sm max-w-sm leading-relaxed">
            {t('about_exp_sub')}
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {offeringsData.map((item, i) => (
            <div
              key={i}
              className="group bg-white/[0.03] border border-white/10 hover:border-[#F57F25]/40 rounded-2xl p-7 transition-all duration-300 hover:bg-white/[0.06]"
            >
              {/* Top row */}
              <div className="flex items-start justify-between mb-5">
                <div className="w-12 h-12 flex items-center justify-center bg-[#F57F25]/10 border border-[#F57F25]/20 rounded-xl group-hover:bg-[#F57F25]/20 transition-colors duration-300">
                  <i className={`${item.icon} text-[#F57F25] text-xl`}></i>
                </div>
                <span className="text-[#F57F25] text-[10px] font-bold tracking-widest uppercase bg-[#F57F25]/10 border border-[#F57F25]/20 px-3 py-1 rounded-full whitespace-nowrap">
                  {t(item.tagKey)}
                </span>
              </div>

              <h3 className="text-white text-lg font-black uppercase mb-3 leading-tight">{t(item.titleKey)}</h3>
              <p className="text-white/55 text-sm leading-relaxed">{t(item.descKey)}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
